module.exports = __webpack_public_path__ + "static/media/United_transparent_white.eceec7b9.svg";